import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Company extends EntityDto implements IEntityDto {
    Company_Id: string;
    CompanyName: string;
    CompanyAddress: string;
    Phone: string;
    EmailId: string;
    TotalCount: number;
    IsActive: boolean;
    Document: any;
    Document_Name: string;
    FileName: string;
    Ref_Id: string | null;
    cinDocument: any;
    Address_Ref_Id: string;
    CIN: string;
    CIN_Ref_Id: string;
    PAN: string;
    PAN_Ref_Id: string;
    PANDocument: any;
    TAN: string;
    TAN_Ref_Id: string;
    TANDocument: any;
    MOA: string;
    MOA_Ref_Id: string;
    MOADocument: any;
    AOA: string;
    AOA_Ref_Id: string;
    AOADocument: any;
    COI: string;
    COI_Ref_Id: string;
    COIDocument: any;
    RBI_License: string;
    RBI_License_Ref_Id: string;
    RBIDocument: any;
    OtherEnclosure: string;
    OtherEnclosure_Ref_Id: string;
    OtherEnclosureDocument: any;
    addressDocument: any;
    CINDocDownload: any;
    PANDocDownload: any;
    TANDocDownload: any;
    AOADocDownload: any;
    MOADocDownload: any;
    COIDocDownload: any;
    RBIDocDownload: any;
    // PANDocDownload: any;
    OtherDocDownload: any;
    AddressFileName:string="";
    CINFileName:string="";
    PANFileName:string="";
    TANFileName:string="";
    MOAFileName:string="";
    AOAFileName:string="";
    COIFileName:string="";
    RBIFileName:string="";
    OtherFileName:string="";
    constructor() {
        super();
        this.Company_Id = "00000000-0000-0000-0000-000000000000";
        this.CompanyName = "";
        this.CompanyAddress = "";
        this.EmailId = "";
        this.TotalCount = 0;
        this.Phone = "";
        this.IsActive = true;
        this.Document = null;
        this.cinDocument = null;
        this.Document_Name = "";
        this.FileName = "";
        this.Ref_Id = "";
        this.Address_Ref_Id = "";

        this.CIN = "";
        this.CIN_Ref_Id = "";
        this.PAN = "";
        this.PAN_Ref_Id = "";
        this.TAN = "";
        this.TAN_Ref_Id = "";
        this.MOA = "";
        this.MOA_Ref_Id = "";
        this.AOA = "";
        this.AOA_Ref_Id = "";
        this.COI = "";
        this.COI_Ref_Id = "";
        this.RBI_License = "";
        this.RBI_License_Ref_Id = "";
        this.OtherEnclosure="";
        this.OtherEnclosure_Ref_Id="";

        this.EntityMetaData = [
            { FieldName: 'CompanyName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company Name is required' },
            //  { FieldName: 'CompanyAddress', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Address is required' },
            { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
        ];
    }
}
